import { TokenActionTypes, Token } from './types';
import { TokenActionType } from './actions';
import { createReducer } from 'typesafe-actions';
import Logger from '../../components/Logger/Logger';

const initialState = {} as Token;

const reducer = createReducer<Token, TokenActionType>(initialState, {
	[TokenActionTypes.PROCESS_TOKEN_SUCCEEDED]: (state, action) => {
		return { ...state, ...action.payload };
	},
	[TokenActionTypes.PROCESS_TOKEN_FAILED]: (_, action) => {
		const ErrorLogger = new Logger();
		ErrorLogger.error(action.payload.message);
		return {} as Token;
	},
	[TokenActionTypes.CLEAR_TOKEN]: () => {
		return {} as Token;
	}
});

export { reducer as tokensReducer };
